module.exports = __webpack_public_path__ + "img/stock6.2cf2a195.png";